import React from 'react'
import {
  Button as BaseButton,
  ButtonLink as BaseButtonLink,
  ButtonHTMLLink as BaseButtonHTMLLink,
  ButtonProps,
  ButtonHTMLLinkProps,
  ButtonLinkProps,
} from '@slite/components'

export const Button = ({ size = 'medium', ...props }: ButtonProps) => (
  <BaseButton {...props} size={size} />
)

export const ButtonLink = ({ size = 'medium', ...props }: ButtonLinkProps) => (
  <BaseButtonLink {...props} size={size} />
)

export const ButtonHTMLLink = ({
  size = 'medium',
  ...props
}: ButtonHTMLLinkProps) => <BaseButtonHTMLLink {...props} size={size} />
